import url from '../url'
import headers from '../headers'

export default {
	getOptions (context) {
		return context.$http.get(
			`${url}/plans/`,
			headers.bearer()
		)
	},
	addSubscription (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/plan/`,
			model,
			headers.bearer()
		)
	},
	
	addCard (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/sources/`,
			model,
			headers.bearer()
		)
	},
	setCard (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/sources/change`,
			model,
			headers.bearer()
		)
	},
	getCards (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/sources/`,
			headers.bearer()
		)
	},
	getPlan (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/plan/`,
			headers.bearer()
		)
	},
	getInvoices (context, user_uid) {
		return context.$http.get(
			`${url}/users/${user_uid}/plan/invoices/`,
			headers.bearer()
		)
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/plan.js